<template>
  <button class="button-request"
    :class="classes">
    <div class="button-request__request-button"
      @click="$emit('call-request')">
      <span>
        <slot />
      </span>
    </div>
    <router-link to="/favorites">
      <div v-show="inFavorites"
        class="button-request__favorite-button">
        <app-svg id="heart"
          class="button-request__favorite-button-icon"
          @click="likeClick" />
        <app-svg id="heart-hover"
          class="button-request__favorite-button-icon button-request__favorite-button-icon_hover"
          @click="likeClick" />
        <sup class="button-request__total">{{ inFavorites }}</sup>
      </div>
    </router-link>
  </button>
</template>

<script>
import { computed, reactive } from "vue";

export default {
  name: "ButtonRequest",
  props: {
    inFavorites: {
      type: Number,
      default: null,
    },
  },

  emits: ["call-request"],

  setup(props) {
    props = reactive(props);

    return {
      classes: computed(() => ({
        "_has-favorites": props.inFavorites,
      })),
    };
  },
  methods: {
    likeClick() {
      this.$emit("to-favorites");
    },
  },
};
</script>

<style lang="scss" scoped>
.button-request {
  $that: &;

  display: flex;

  &:hover {}

  &:active {}

  &__request-button {
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 48px;
    padding: 20px 40px;
    text-transform: uppercase;
    cursor: pointer;
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    transition: border-color 0.8s 0.25s cubic-bezier(0.25, 1, 0.3, 1);
    color: white;
    border: 1px solid $color_orange-50;
    background: $color_orange-50;
    border-radius: 24px;
    text-decoration: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    min-width: 162px;

    &::before {
      content: "";
      @include absolute-fill;
      background-color: rgba(255, 255, 255, 0.3);
      z-index: 2;
      clip-path: circle(0% at bottom left);
      transition: clip-path 0.8s 0.1s cubic-bezier(0.25, 1, 0.3, 1);

      @keyframes circle-in-top-left {
        from {
          clip-path: circle(0%);
        }

        to {
          clip-path: circle(150% at bottom left);
        }
      }
    }

    &._white {
      .button-request__request-button {
        background-color: $white;
        color: $color_orange-50;
      }
    }

    span {
      position: relative;
      z-index: 2;
    }

    // &:hover {
    //   border-color: rgba(255, 255, 255, 0.3);

    //   &::before {
    //     clip-path: circle(150% at top left);
    //   }
    // }

    @include laptop {
      display: none;
    }
  }

  &__favorite-button {
    color: $white;
    margin-left: 24px;

    @include laptop {
      border: 0;
      padding: 0;
    }

    @include flex-center;

    position: relative;
    width: 46px;
    height: 46px;
    transition: color 0.25s ease-out;

    @include phone {
      width: 32px;
      height: 32px;
      margin-left: 0;
      margin-right: 16px;
    }

    &-icon {
      position: absolute;
      opacity: 1;
      width: 100%;
      height: 100%;
      transition: opacity .3s ease;

      &_hover {
        opacity: 0;
      }
    }

    &:hover {
      #{$that}__favorite-button-icon {
        opacity: 0;

        &_hover {
          opacity: 1;
        }
      }
    }
  }

  &__total {
    flex: none;
    color: $white;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    transform: translate3d(0, -50%, 0);
    position: absolute;
    right: -24px;
    top: 50%;

    @include phone {
      display: none;
    }
  }

  @keyframes heartbeat {
    0% {
      transform: scale(1.1);
    }
  }
}
</style>
